var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.checkPermi(["merchant:order:page:list"])
    ? _c(
        "div",
        { staticClass: "divBox relative" },
        [
          _vm.showActivityHeader
            ? _c("pages-header", {
                attrs: {
                  title: _vm.activityHeaderTitle,
                  backUrl: "/activity-product/list",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "right",
                      fn: function () {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["merchant:export:order:excel"],
                                  expression: "['merchant:export:order:excel']",
                                },
                              ],
                              attrs: {
                                size: "small",
                                loading: _vm.exportLoading,
                              },
                              on: { click: _vm.exports },
                            },
                            [_vm._v("导出")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  37853041
                ),
              })
            : _vm._e(),
          !_vm.showActivityHeader
            ? _c(
                "el-card",
                {
                  staticClass: "ivu-mt",
                  attrs: {
                    bordered: false,
                    shadow: "never",
                    "body-style": { padding: 0 },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "padding-add" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: { inline: "", "label-position": "right" },
                          nativeOn: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "订单编号：",
                                "label-width": "66px",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "form_content_width",
                                attrs: {
                                  placeholder: "请输入订单号",
                                  size: "small",
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleSearchList($event)
                                  },
                                },
                                model: {
                                  value: _vm.tableFrom.orderNo,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.tableFrom,
                                      "orderNo",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "tableFrom.orderNo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "订单状态：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "form_content_width",
                                  attrs: { size: "small" },
                                  on: { change: _vm.handleSearchList },
                                  model: {
                                    value: _vm.tableFrom.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.tableFrom, "status", $$v)
                                    },
                                    expression: "tableFrom.status",
                                  },
                                },
                                _vm._l(_vm.statusOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "业务类型：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "form_content_width",
                                  attrs: { clearable: "", size: "small" },
                                  on: { change: _vm.handleSearchList },
                                  model: {
                                    value: _vm.tableFrom.merchantType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tableFrom,
                                        "merchantType",
                                        $$v
                                      )
                                    },
                                    expression: "tableFrom.merchantType",
                                  },
                                },
                                _vm._l(
                                  _vm.merchantTypeOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "时间选择：" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "form_content_width",
                                attrs: {
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd",
                                  size: "small",
                                  type: "daterange",
                                  placement: "bottom-end",
                                  placeholder: "自定义时间",
                                },
                                on: { change: _vm.onchangeTime },
                                model: {
                                  value: _vm.timeVal,
                                  callback: function ($$v) {
                                    _vm.timeVal = $$v
                                  },
                                  expression: "timeVal",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "用户搜索：",
                                "label-for": "nickname",
                              },
                            },
                            [
                              _c("UserSearchInput", {
                                model: {
                                  value: _vm.tableFrom,
                                  callback: function ($$v) {
                                    _vm.tableFrom = $$v
                                  },
                                  expression: "tableFrom",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleSearchList },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.handleReset },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "el-card",
            {
              staticClass: "box-card mt16",
              attrs: {
                shadow: "never",
                bordered: false,
                "body-style": { padding: "0 20px 20px" },
              },
            },
            [
              !_vm.showActivityHeader
                ? _c(
                    "div",
                    { staticClass: "table-toolbar" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["merchant:export:order:excel"],
                              expression: "['merchant:export:order:excel']",
                            },
                          ],
                          attrs: { size: "small", loading: _vm.exportLoading },
                          on: { click: _vm.exports },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  class: _vm.showActivityHeader ? "" : "mt20",
                  attrs: {
                    data: _vm.tableData.data,
                    size: "mini",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "订单号", "min-width": "190" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.orderNo))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2388026409
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "用户昵称", "min-width": "140" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  class: scope.row.isLogoff
                                    ? "colorPrompt"
                                    : "",
                                },
                                [_vm._v(_vm._s(scope.row.nickName || "-"))]
                              ),
                              scope.row.isLogoff
                                ? _c("span", { staticClass: "colorPrompt" }, [
                                    _vm._v(" (已注销)"),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1525162725
                    ),
                  }),
                  _vm.hasDynamicFormColumns
                    ? _vm._l(_vm.systemFormColumns, function (column) {
                        return _c("el-table-column", {
                          key: column.key,
                          attrs: {
                            label: column.label,
                            "min-width": "180",
                            "show-overflow-tooltip": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getDynamicColumnValue(
                                            scope.row,
                                            column
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      })
                    : [
                        _c("el-table-column", {
                          attrs: {
                            prop: "merchantTypeName",
                            label: "业务类型",
                            "min-width": "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "activityReservationDate",
                            label: "预约日期",
                            "min-width": "160",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "productInfo",
                            label: "商品信息",
                            "min-width": "220",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "retentionSummary",
                            label: "留资摘要",
                            "min-width": "280",
                            "show-overflow-tooltip": "",
                          },
                        }),
                      ],
                  _c("el-table-column", {
                    attrs: {
                      prop: "payPrice",
                      label: "实际支付金额",
                      "min-width": "110",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "couponPrice",
                      label: "消费券金额",
                      "min-width": "110",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalPrice",
                      label: "订单金额",
                      "min-width": "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单状态", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formatOrderStatus(scope.row))
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2669148304
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "预约人数", "min-width": "240" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatFreeActivitySummary(scope.row)
                                  )
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3921127231
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { width: "80", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm.checkPermi(["merchant:order:info"])
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onOrderDetails(
                                            scope.row.orderNo
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2216314709
                    ),
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "block" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-sizes": _vm.$constants.page.limit,
                      "page-size": _vm.tableFrom.limit,
                      "current-page": _vm.tableFrom.page,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.tableData.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("details-from", {
            ref: "orderDetail",
            attrs: { orderNo: _vm.orderNo },
            on: { "free-activity-changed": _vm.getList },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }